const state = {
  chartData: [],
  contents: []
  // ,obj: {
  //   productName: '',
  //   proDiscript: '',
  //   original: null,
  //   discounts: null,
  //   imgSrc: [],
  //   specificates: [
  //     {
  //       sizeSelected: '',
  //       color: '',
  //       inventory: null
  //     },
  //     {
  //       sizeSelected: '',
  //       color: '',
  //       inventory: null
  //     }
  //   ],
  //   status: null
  // }
}

export default state



// WEBPACK FOOTER //
// ./src/store/rootState.js